import { render } from "./FormOrdine.vue?vue&type=template&id=5339e9db&scoped=true"
import script from "./FormOrdine.vue?vue&type=script&lang=js"
export * from "./FormOrdine.vue?vue&type=script&lang=js"

import "./FormOrdine.vue?vue&type=style&index=0&id=5339e9db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5339e9db"]])

export default __exports__